
const fakeAuth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 0)
  },
  signout(cb) {
    this.isAuthenticated = false
    setTimeout(cb, 0)
  }
}

export default fakeAuth;


// WEBPACK FOOTER //
// ./src/views/autha.js